import React, { Component } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Footer } from "./footer/Footer";
import { WhatsappWidget } from "./widget/WhatsappWidget";
import { NavBar } from "./header/NavBar";
import { HomeScreen } from "./home/HomeScreen";
import { NovedadesInterna } from "./home/novedades/NovedadesInterna";
import { ActoDeAdjudicacion } from "./internas/actoDeAdjudicacion/ActoDeAdjudicacion";
import { GastosDeEntrega } from "./internas/gastosDeEntrega/GastosDeEntrega";
import { CanalesDeAtencion } from "./internas/canalesDeAtencion/CanalesDeAtencion";
import { ResultadosPorMes } from "./internas/actoDeAdjudicacion/ResultadosPorMes";
import { ConoceFiatPlan } from "./internas/conoceFiatPlan/ConoceFiatPlan";
import { Anexos } from "./internas/informacionGeneral/Anexos";
import { InformacionGeneral } from "./internas/informacionGeneral/InformacionGeneral";
import { EasyTracking } from "./miPlan/planInternas/easyTracking/EasyTracking";
import { HaberNeto } from "./miPlan/planInternas/haberNeto/haberNeto";
import { PuestaADisposicion } from "./internas/informacionGeneral/PuestaADisposicion";
import { GruposFinalizados } from "./internas/informacionGeneral/GruposFinalizados";
import { PoliticaPrivacidad } from "./internas/legales/PoliticaPrivacidad";
import { PactoClaro } from "./internas/PactoClaro";
import { Mandamientos } from "./internas/Mandamientos";
import { Terminos } from "./internas/legales/Terminos";
import { PlanesScreen } from "./internas/planes/PlanesScreen";
import { LegalesInterna } from "./internas/legales/LegalesInterna";
import { PreguntasFrecuentes } from "./internas/preguntasFrecuentes/PreguntasFrecuentes";
import { NotFound } from "./notFound/NotFound";
import ScrollToTop from "./scrollToTop/ScrollToTop";
import { MasInfoPlan } from "./internas/legales/MasInfoPlan";
import { PublicRouter } from "../../../routes/publicRouter";
import { PrivateRouter } from "../../../routes/privateRouter";
import { NuevoUsuario } from "./miPlan/UI/NuevoUsuario";
import { NuevoUsuario2 } from "./miPlan/UI/NuevoUsuario2";
import { NuevoUsuario3 } from "./miPlan/UI/NuevoUsuario3";
import { RecuperarContrasenaPaso1 } from "./miPlan/UI/RecuperarContrasenaPaso1";
import { RecuperarContrasenaPaso2 } from "./miPlan/UI/RecuperarContrasenaPaso2";
import { RecuperarContrasenaPaso3 } from "./miPlan/UI/RecuperarContrasenaPaso3";
import { DesbloquearUsuarioPaso1 } from "./miPlan/UI/DesbloquearUsuarioPaso1";
import { DesbloquearUsuarioPaso2 } from "./miPlan/UI/DesbloquearUsuarioPaso2";
import { DesbloquearUsuarioPaso3 } from "./miPlan/UI/DesbloquearUsuarioPaso3";
import { Verificacion } from "./miPlan/UI/Verificacion";
import { EnviadoConExito } from "./miPlan/UI/EnviadoConExito";
import { Cuotas } from "./miPlan/planInternas/cuotas/Cuotas";
import { MisDatos } from "./miPlan/planInternas/misDatos/MisDatos";
import { Notificaciones } from "./miPlan/planInternas/Notificaciones/Notificaciones";
import AppProvider from "../Context/Context";
import { Login } from "./miPlan/UI/Login";
import { SeleccionPlan } from "./miPlan/planInternas/seleccionPlan/SeleccionPlan";
import { Inicio } from "./miPlan/planInternas/inicio/Inicio";
import { Pagar } from "./miPlan/planInternas/cuotas/Pagar";
import { Instructuctivos } from "./miPlan/planInternas/instructivos/Instructivos";
import { Concesionarios } from "./internas/concesionarios/Concesionarios";

export default class App extends Component {

    componentDidMount() {
        this.addRobotsMetaTag();
    }

    addRobotsMetaTag = async () => {
        try {
            const response = await fetch('/get_qa_environment_index_tag');
            if (!response.ok) {
                throw new Error('Failed to fetch QA environment index tag');
            }
            const data = await response.json();

            // Add the meta tag only if the value is 'noindex'
            if (data.qaEnvironmentIndexTag === 'noindex') {
                const metaTag = document.createElement('meta');
                metaTag.name = 'robots';
                metaTag.content = 'noindex';
                document.head.appendChild(metaTag);
            }
        } catch (error) {
            console.error('Error fetching QA environment index tag:', error);
        }
    };

    render() {
        let isValid = sessionStorage.getItem("dtvalid");
        if (isValid !== null) {
            isValid = atob(isValid);
        } else {
            isValid = false;
        }
        return (
            <Router>
                <ScrollToTop />
                <AppProvider>
                    <NavBar />
                    <div className="paddingBody">
                        <Switch>
                            <Route exact path="/" component={HomeScreen} />
                            <Route
                                exact
                                path="/pacto_claro"
                                component={PactoClaro}
                            />
                            <Route
                                exact
                                path="/mandamientos"
                                component={Mandamientos}
                            />
                            <Route
                                exact
                                path="/acto_de_adjudicacion"
                                component={ActoDeAdjudicacion}
                            />
                            <Route
                                exact
                                path="/gastos_de_entrega"
                                component={GastosDeEntrega}
                            />
                            <Route
                                exact
                                path="/canales_de_atencion"
                                component={CanalesDeAtencion}
                            />
                            <Route
                                exact
                                path="/informacion_general"
                                component={InformacionGeneral}
                            />
                            <Route
                                exact
                                path="/conoce_fiat_plan"
                                component={ConoceFiatPlan}
                            />
                            <Route
                                exact
                                path="/preguntas_frecuentes"
                                component={PreguntasFrecuentes}
                            />
                            <Route
                                exact
                                path="/terminos_y_condiciones"
                                component={Terminos}
                            />
                            {/* <Route exact path="/politicas_de_privacidad" component={PoliticaPrivacidad} /> */}
                            <Route
                                exact
                                path="/informacion_general/anexos"
                                component={Anexos}
                            />
                            <Route
                                exact
                                path="/informacion_general/grupos_finalizados"
                                component={GruposFinalizados}
                            />
                            <Route
                                exact
                                path="/informacion_general/puesta_disposicion"
                                component={PuestaADisposicion}
                            />
                            <Route
                                exact
                                path="/planes/auto/:id"
                                component={PlanesScreen}
                            />
                            <Route
                                exact
                                path="/legales/:id"
                                component={LegalesInterna}
                            />
                            <Route
                                exact
                                path="/acto_de_adjudicacion/resultados_por_mes/:anio"
                                component={ResultadosPorMes}
                            />
                            <Route
                                exact
                                path="/novedades/:id"
                                component={NovedadesInterna}
                            />
                            <Route
                                exact
                                path="/mas_informacion_plan"
                                component={MasInfoPlan}
                            />
                            <Route
                                exact
                                path="/concesionarios/listado"
                                component={Concesionarios}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/nuevo_usuario"
                                component={NuevoUsuario}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/nuevo_usuario_cuil"
                                component={NuevoUsuario2}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/nuevo_usuario_contrasena_ingresa_clave"
                                component={NuevoUsuario3}
                            />
                            <PublicRouter
                                isAuthenticated={false}
                                exact
                                path="/login_mi_plan"
                                component={Login}
                            />
                            <Route
                                exact
                                path="/seleccion_arrepentimiento_plan/:CUIT"
                                component={SeleccionPlan}
                            />

                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/seleccion_plan"
                                component={SeleccionPlan}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/inicio"
                                component={Inicio}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/cuotas"
                                component={Cuotas}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/recuperar_contrasena"
                                component={RecuperarContrasenaPaso1}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/recuperar_contrasena_ingresa_email"
                                component={RecuperarContrasenaPaso2}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/recuperar_contrasena_ingresa_clave"
                                component={RecuperarContrasenaPaso3}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/desbloquear_usuario"
                                component={DesbloquearUsuarioPaso1}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/desbloquear_usuario_ingresa_email"
                                component={DesbloquearUsuarioPaso2}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/desbloquear_usuario_ingresa_clave"
                                component={DesbloquearUsuarioPaso3}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/verificacion"
                                component={Verificacion}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/enviado_con_exito"
                                component={EnviadoConExito}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/mis_datos"
                                component={MisDatos}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/notificaciones"
                                component={Notificaciones}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/pagar"
                                component={Pagar}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/instructivos"
                                component={Instructuctivos}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/easy_tracking"
                                component={EasyTracking}
                            />
                            <PrivateRouter
                                isAuthenticated={true}
                                exact
                                path="/haber_neto"
                                component={HaberNeto}
                            />
                            <Route component={NotFound} />
                        </Switch>
                    </div>
                    <WhatsappWidget />
                    <Footer />
                </AppProvider>
            </Router>
        );
    }
}

if (document.getElementById("root")) {
    ReactDOM.render(<App />, document.getElementById("root"));
}
